module.exports = __webpack_public_path__ + "static/media/itsolutions-header-bg.93845ecd.png";